import * as React              from "react";
import {createContext}         from "react";
import {FontAwesomeIcon}       from "@fortawesome/react-fontawesome";
import {faRotateRight, faCopy} from "@fortawesome/free-solid-svg-icons";

import "./suggestion-result.scss";

import {cs}             from "@Common/react/chain-services";
import {UseState}       from "@Common/react/use-state";
import {consumeContext} from "@Common/react/context";
import {ScreenLoader}   from "@Common/ui-components/loading-spinners/screen-loader";
import {isDevXd}        from "@Common/ui-components/debug/is-dev";
import {WizardTool}     from "./wizard-tool";

export const SuggestionResult = ({idOrder, item, field, suggestion, fieldSuggestions, loading, propertyWizardInsertValues}) => cs(
    consumeContext("apis"),
    ["moreLikeCurrentSuggestion", ({apis}, next) => next(async () => {
         try {
            loading.onChange(true);
            fieldSuggestions.onChange([]);
            let timeout, failureValue="ERROR: timeout", timeLimit=26000;
            const timeoutPromise = new Promise((resolve, reject) => {
                timeout = setTimeout(() => {
                    resolve(failureValue);
                }, timeLimit);
            });
            let task = apis.next.gpt.generateFieldSuggestions({
                idOrder: parseInt(idOrder),
                numOfSuggestions: 3,
                idProductType: parseInt(item.idProductType),
                field: {
                    idPrimary: field.idPrimary,
                    fieldKey: field.fieldKey,
                    displayLabel: field.displayLabel,
                    maxLength: field.maxLength,
                    enableLimitOverride: field.enableLimitOverride,
                },
                moreLikeThisCopy: suggestion.content,
            });
            let results = await Promise.race([task, timeoutPromise]);
            if(results.error || typeof results == "string") {
                isDevXd() && console.error(`Error processing field ${field.displayLabel}:`);
                fieldSuggestions.onChange([{
                    content : "",
                    displayLabel : field.displayLabel,
                    finishReason : "error",
                    idPrimary : field.idPrimary,
                    error: "Failed to generate suggestions",
                }]);
                loading.onChange(false);
            } else {
                fieldSuggestions.onChange(results);
            }
        } catch (error) {
            console.error("Error fetching property wizard data:", error);
            fieldSuggestions.onChange([{
                content : "",
                displayLabel : field.displayLabel,
                finishReason : "error",
                idPrimary : field.idPrimary,
                error: "Failed to generate suggestions",
            }]);
            loading.onChange(false);
        }
    })],
    ["contextLabel", ({}, next) => next(`field_${field.idPrimary}`)],
    ({moreLikeCurrentSuggestion}) => (
        <div className="suggestion-result">
            <p>{suggestion.content}</p>
            <div className="suggestion-actions">
                <WizardTool
                    tooltipCopy="More like this"
                    onClickFunction={moreLikeCurrentSuggestion}
                >
                    <FontAwesomeIcon icon={faRotateRight}/>
                </WizardTool>
                <WizardTool
                    tooltipCopy="Copy"
                    onClickFunction={() =>
                        navigator.clipboard.writeText(suggestion.content)
                            .catch(err => isDevXd() && console.error("Failed to copy suggestion: ", err))
                    }
                >
                    <FontAwesomeIcon icon={faCopy}/>
                </WizardTool>
                <div className="insert-suggestion"
                    onClick={() => {
                        propertyWizardInsertValues.onChange({
                            ...propertyWizardInsertValues.value,
                            [field.idPrimary]: suggestion.content
                        });
                    }}
                >
                    INSERT
                </div>
            </div>
        </div>
    )
)